import { getCreatorApiUrl } from '@client/components/api-urls';
import auth from '@client/components/auth';
import axios from 'axios';
import { httpClient } from './api';

export const addStripe = async (authorizationCode: string) => {
  const token = auth.getToken();
  const user = auth.getUser();
  const influencerId = user.influencerId;

  await axios.post(
    getCreatorApiUrl(`/admin-influencers/${influencerId}/add-stripe`),
    {
      code: authorizationCode,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
};

export const getStripeConnectUrlRaw = (user: {
  email?: string;
  firstName?: string;
  lastName?: string;
  // customURL: string;
  profileDeepLink?: string;
}) => {
  const baseConnectUrl = 'https://connect.stripe.com/express/oauth/authorize';
  const clientId = import.meta.env.VITE_STRIPE_CONNECT_ID;
  const redirectUri = window.location.origin + '/stripe-callback';
  // const customURL = user.customURL
  //   ? `${import.meta.env.VITE_LANDING_PAGE_URL}/${user.customURL}`
  //   : user.profileDeepLink;

  const queryParams = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    'stripe_user[first_name]': user.firstName || '',
    'stripe_user[last_name]': user.lastName || '',
    // 'stripe_user[url]': customURL ||,
    'stripe_user[email]': user.email || '',
  });

  return `${baseConnectUrl}?${queryParams.toString()}`;
};

export const getStripeConnectUrl = async (influencerId: number) => {
  const token = auth.getToken();
  const url = getCreatorApiUrl(
    `/admin-influencers/${influencerId}/create-stripe-account`,
  );

  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return res.data.connectLink;
};

export const verifyStripeMode = async (influencerId: number) => {
  const token = auth.getToken();
  const url = getCreatorApiUrl(
    `/admin-influencers/${influencerId}/verify-stripe-account`,
  );
  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return res.data.isLive;
};

export const getStripeLoginUrl = async (influencerId: number) => {
  const res = await httpClient.get(
    getCreatorApiUrl(`/admin-influencers/${influencerId}/get-stripe-login`),
  );

  return res.data;
};

export const removeStripe = async (influencerId: number) => {
  return httpClient.post(
    getCreatorApiUrl(`/admin-influencers/${influencerId}/remove-stripe`),
    {},
  );
};
